import { footerData } from '@/mocks/home';

export default function Footer() {
  const handleNav = (href: string) => {
    const id = href.replace('#', '');
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="bg-background-950 text-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-3">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-fire-line text-white text-base"></i>
              </span>
              <span className="font-heading text-lg text-background-50">51吃瓜黑料网</span>
            </div>
            <p className="text-xs text-background-400 leading-relaxed mb-4">
              {footerData.description}
            </p>
            <div className="flex items-center gap-3">
              <span className="w-8 h-8 flex items-center justify-center bg-background-800 rounded-lg text-background-300 hover:text-background-100 hover:bg-primary-600 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </span>
              <span className="w-8 h-8 flex items-center justify-center bg-background-800 rounded-lg text-background-300 hover:text-background-100 hover:bg-primary-600 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </span>
              <span className="w-8 h-8 flex items-center justify-center bg-background-800 rounded-lg text-background-300 hover:text-background-100 hover:bg-primary-600 transition-colors cursor-pointer">
                <i className="ri-telegram-line text-sm"></i>
              </span>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-sm text-background-100 mb-4">快速导航</h3>
            <ul className="space-y-2">
              {footerData.quickLinks.map((link, i) => (
                <li key={i}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      handleNav(link.href);
                    }}
                    className="text-xs text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm text-background-100 mb-4">热门话题</h3>
            <ul className="space-y-2">
              {footerData.topics.map((t, i) => (
                <li key={i}>
                  <a
                    href={t.href}
                    onClick={(e) => {
                      e.preventDefault();
                      handleNav(t.href);
                    }}
                    className="text-xs text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {t.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm text-background-100 mb-4">合作伙伴</h3>
            <p className="text-xs text-background-500 leading-relaxed">
              诚邀优质内容平台与品牌方合作，共同打造健康、有价值的娱乐资讯生态。合作洽谈请联系上方投稿邮箱，我们将在24小时内回复。
            </p>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2023-2026 51吃瓜黑料网 | 本站内容均来源于公开网络信息，仅供娱乐参考
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-background-500 cursor-pointer hover:text-background-300 transition-colors">隐私政策</span>
            <span className="text-xs text-background-500 cursor-pointer hover:text-background-300 transition-colors">免责声明</span>
            <span className="text-xs text-background-500 cursor-pointer hover:text-background-300 transition-colors">用户协议</span>
          </div>
        </div>
      </div>
    </footer>
  );
}